export default __webpack_public_path__ + "static/media/1305.173f2f1b.png";